import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, ReplaySubject, catchError, tap, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { FuseLoadingService } from '@fuse/services/loading';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'environments/environment';
import { FuseSplashScreenService } from '@fuse/services/splash-screen';
import { FuseConfirmationService } from '@fuse/services/confirmation';


@Injectable({providedIn: 'root'})

export class ApiOrderService {


    
    constructor(
        private _loadingBar : FuseLoadingService,
        private _splashScreeh: FuseSplashScreenService,
        private sckaBar: MatSnackBar,
        private http: HttpClient,
        private _fuseConfirmation: FuseConfirmationService
    ) 
    {
    }


    /** Properties */


    get serverUrl() {
        return `${environment.API_ORDERS_STORE_URL}/api`
    }
 
    /**
     * 
     * @param endpoint API endpoint to fetch data
     * @param params   json params objetc
     * @param errorMessage  string text displaying when status code !=200
     * @returns 
     */
    
    GetMethod(_url: string, params?, errorMessage?:string, showAlertOnError: boolean = true) {
        this._splashScreeh.show()
        const url =  `${this.serverUrl}${_url}`
        return this.http.get(url, { params})
                        .pipe(
                            tap(response => {
                                this._splashScreeh.hide()
                            }),
                            catchError((error: HttpErrorResponse) => {
                                this._splashScreeh.hide();
                                //
                                let _message = this.build_error_message(error,  errorMessage)
                                if (showAlertOnError){
                                    this.showErrorMessage(_message)

                                }
                                return throwError(_message)
                            })
                        );
    }


    GetMethodv2(_url: string, params?, errorMessage?:string, showAlertOnError: boolean = true) {
        this._splashScreeh.show()
        const url =  `${this.serverUrl}${_url}`
        return this.http.get(url, { params})
                        .pipe(
                            tap(response => {
                                this._splashScreeh.hide()
                            }),
                            catchError((error: HttpErrorResponse) => {
                                this._splashScreeh.hide();
                                //
                                let _message = this.build_error_message(error,  errorMessage)
                                if (showAlertOnError){
                                    this.showErrorMessage(_message)

                                }
                                return throwError(error.error)
                            })
                        );
    }

    /**
     * Global POST Method
     * @param endpoint url endpoint
     * @param params  optional query params 
     * @param errorMessage  custom error message to be displayed 
     * @param useOrganization boolean default false 
     * @returns 
     */
    PostMethod(_url: string, body:any, params?, errorMessage?:string, noLoader?: boolean, hideModalErrorMessage? :boolean ){

        noLoader ? '' : this._splashScreeh.show();
        const url =  `${this.serverUrl}${_url}`
        return this.http.post(url, body, {params})
                        .pipe(
                            tap(response => {
                                noLoader ? '' : this._splashScreeh.hide();
                            }),
                            catchError((error: HttpErrorResponse) => {
                                noLoader ? '' : this._splashScreeh.hide();
                                //
                                let _message = this.build_error_message(error,  errorMessage)
                                if (!hideModalErrorMessage)
                                    this.showErrorMessage(_message)
                                
                                return throwError(_message)
                            })
                        );
    }

    PutMethod(_url: string, body:any, params?, errorMessage?:string) {
        this._splashScreeh.show()
        const url =  `${this.serverUrl}${_url}`
        return this.http.put(url, body, {params})
                        .pipe(
                            tap(response => {
                                this._splashScreeh.hide()
                            }),
                            catchError((error: HttpErrorResponse) => {
                                this._splashScreeh.hide();
                                //
                                let _message = this.build_error_message(error,  errorMessage)
                                this.showErrorMessage(_message)
                                return throwError(this.showErrorMessage(_message))
                            })
                        );
    }

    DeleteMethod(_url: string,  params?, errorMessage?:string) {
        this._splashScreeh.show()
        const url =  `${this.serverUrl}${_url}`
        return this.http.delete(url, {params})
                        .pipe(
                            tap(response => {
                                this._splashScreeh.hide()
                            }),
                            catchError((error: HttpErrorResponse) => {
                                this._loadingBar.hide();
                                //
                                let _message = this.build_error_message(error,  errorMessage)
                                this.showErrorMessage(_message)
                                return throwError(error)
                            })
                        );
    }


    build_error_message(error: HttpErrorResponse, message?:string){
        const body: any = error.error;

        const messageResponse =
            body && typeof body === 'object'
                ? (body.Message || body.message || body?.Data?.message)
                : null;

        let server_error_response = messageResponse || message ||
            'No es posible completar la solicitud en este momento, intente más tarde';

        return `${server_error_response}`;
    }

    showErrorMessage(message?:string){
        
        // return this.sckaBar.open(
        //     message,
        //     '',
        //     {
        //         duration: 4000,
        //         verticalPosition: 'top',
        //         panelClass: ['bg-rose-600/70','text-white']
        //     }
        // )

        
        return  this._fuseConfirmation.open( {
            title: 'Ups!',
            message: message,
            icon: {
                show: true,
                name: 'error',
                color:'warning'
            },
            actions: {
                confirm: { show: false},
                cancel: {show:  true}
            },
            dismissible:true

        }) 

    }

    showSuccessMessage(message?: string){
        return this.sckaBar.open(
            message,
            '',
            {
                duration: 4000,
                verticalPosition: 'top',
                panelClass: ['bg-sky-400/70', 'text-white']
            },
            
        )

    }




    postFormDataFiles(endpoint: string, files: File[], errorMessage?: string) {

        this._splashScreeh.show()
        const url =`${this.serverUrl}${endpoint}`;
        const formData = new FormData();

        files.forEach(file => {
            formData.append('files', file, file.name);
        });


        return this.http.post(url, formData).pipe(
            tap(response => { 
                this._splashScreeh.hide();
                this.showSuccessMessage('Archivos subidos satisfactoriamente.')
            }),
            catchError((error: HttpErrorResponse) => {
                this._splashScreeh.hide()
                let _message =  this.build_error_message(error, errorMessage)
                this.showErrorMessage(_message)
                return throwError(error);
            })
        );
    }


    _getMethod(url: string, params?, errorMessage?: string) {
        this._splashScreeh.show()
        return this.http.get(url, { params})
                        .pipe(
                            tap(response => {
                                this._splashScreeh.hide()
                            }),
                            catchError((error: HttpErrorResponse) => {
                                this._splashScreeh.hide();
                                //
                                let _message = this.build_error_message(error,  errorMessage)
                                this.showErrorMessage(_message)
                                return throwError(this.showErrorMessage(_message))
                            })
                        );
    }



    PostMethodV2(_url: string, body:any, params?, errorMessage?:string, noLoader?: boolean, hideModalErrorMessage? :boolean ){

        noLoader ? '' : this._splashScreeh.show();
        const url =  `${this.serverUrl}${_url}`
        return this.http.post(url, body, {params})
                        .pipe(
                            tap(response => {
                                noLoader ? '' : this._splashScreeh.hide();
                            }),
                            catchError((error: HttpErrorResponse) => {
                              
                                return throwError(error)
                            })
                        );
    }
    
}
